export default "__VITE_ASSET__Cu9QrZRE__"